import WheelTimePicker from '@components/common/WheelTimePicker';

export const partFields = [
  {
    name: 'Part',
    noArrow: true,
    key: 'partNumber',
    small: false,
    placeholder: 'Part Number',
    maxLength: 40,
  },
  {
    name: 'Drawing',
    noArrow: true,
    key: 'partDrawingNumber',
    small: false,
    placeholder: 'Drawing Number',
    maxLength: 40,
  },
  {
    name: 'Revision',
    noArrow: true,
    key: 'partDrawingRevision',
    small: false,
    placeholder: 'Revision',
    maxLength: 40,
  },
  {
    name: 'Pos',
    noArrow: true,
    key: 'partDrawingPosition',
    small: false,
    placeholder: 'Pos',
    maxLength: 10,
  },
  {
    name: 'Description',
    noArrow: true,
    small: false,
    key: 'partDescription',
    placeholder: 'Description',
    maxLength: 120,
  },
];

export const timeTypeConfig = [
  {
    name: 'Manual',
    key: 'manual',
  },
  {
    name: 'Automatic',
    key: 'automatic',
  },
];

export const pieceTimeConfig = [
  {
    name: 'Runtime',
    Component: WheelTimePicker,
    noArrow: true,
    key: 'runtime',
    isTime: true,
    small: false,
  },
  {
    name: 'Change time',
    Component: WheelTimePicker,
    noArrow: true,
    key: 'changeTime',
    isTime: true,
    small: false,
  },
];

export const batchTimeConfig = [
  {
    name: 'Setup time',
    Component: WheelTimePicker,
    noArrow: true,
    key: 'setupTime',
    isTime: true,
    small: false,
  },
];
